<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" toggleButtonSize="small">
      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" size="small" @click="exportData">{{ $t('export') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="searchParams.from" :model="searchParams.from" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
          <v-select :options="callStatusOptions" :reduce="label => label.value" :placeholder="$t('treatment_result')" v-model="searchParams.call_status" class="md:mb-0 mb-3" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="searchParams.to" :model="searchParams.to" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
          <vs-input :placeholder="$tc('ivr_staff')" v-model="searchParams.ivr_query" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <v-select :options="didOptions" :reduce="label => label.value" :placeholder="$t('did')" v-model="searchParams.service_name" class="md:mb-3 mb-3" />
          <vs-input :placeholder="$tc('disposition')" v-model="searchParams.disposition" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$tc('number')" v-model="searchParams.src" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadAgentInboundDetailsReports(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="inboundDetailsDataContainer" :title="$t('inbound_details')" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-call-statistics-tab-nav></shared-call-statistics-tab-nav>
      </template>

      <shared-inbound-details-list
        :cdrDatas="cdrDatas"
        :customFields="customFields"
        :activeColumns="activeColumns"
      ></shared-inbound-details-list>

      <template slot="footer">
        <paginate
          :total="cdrPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadAgentInboundDetailsReports"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>
  </div>
</template>

<script>
import Paginate from '@/components/Paginate'
import SharedCallStatisticsTabNav from '@/views/Shared/CallStatistics/TabNav'
import DatePicker from '@/components/form-inputs/DatePicker'
import AgentInboundDetailsReport from '@/models/AgentInboundDetailsReport'
import Pagination from '@/mixins/paginate'
import SharedInboundDetailsList from '@/views/Shared/InboundDetails/List'
import SharedUserConsultationList from '@/views/Shared/Consultations/Consultations/List.vue'

export default {
  name: 'User.CallStatistics.InboundDetails',
  mixins: [Pagination],
  components: {
    SharedUserConsultationList,
    SharedCallStatisticsTabNav,
    DatePicker,
    Paginate,
    SharedInboundDetailsList
  },
  data () {
    return {
      customFields: {},
      activeColumns: {},
      cdrDatas: {},
      cdrPages: 1,
      initialPage: typeof this.$route.query.page !== 'undefined' && this.$route.query.page > 0 ? parseInt(this.$route.query.page) : 1,
      cdrListCount: 0,
      didOptions: [],
      callStatusOptions: [],
      itemPerPage: null,
      searchParams: {
        from: typeof this.$route.query.from !== 'undefined' ? this.$route.query.from : this.$momentHelper.getCurrentDate(),
        to: typeof this.$route.query.to !== 'undefined' ? this.$route.query.to : this.$momentHelper.getCurrentDate(),
        call_status: typeof this.$route.query.call_status !== 'undefined' ? this.$route.query.call_status : '',
        service_name: typeof this.$route.query.service_name !== 'undefined' ? this.$route.query.service_name : '',
        src: typeof this.$route.query.src !== 'undefined' ? this.$route.query.src : '',
        ivr_query: typeof this.$route.query.ivr_query !== 'undefined' ? this.$route.query.ivr_query : '',
        disposition: typeof this.$route.query.disposition !== 'undefined' ? this.$route.query.disposition : ''
      },
      companyId: this.$store.getters.userInfo.company.id
    }
  },
  mounted () {
    this.loadAgentInboundDetailsReports(this.initialPage, null)
  },
  methods: {
    async loadAgentInboundDetailsReports (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#inboundDetailsDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      this.$router.replace({ query: { ...this.searchParams, page, itemPerPage } })
      const response = await AgentInboundDetailsReport.findAll({ ...this.searchParams, page, itemPerPage })
      this.cdrDatas = response.data.data.inboundDetails
      this.cdrPages = response.data.meta.pagination.last_page
      this.didOptions = response.data.meta.options.dids
      this.callStatusOptions = response.data.meta.options.callStatuses
      this.activeColumns = response.data.meta.activeColumns
      this.customFields = response.data.meta.customFields
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#inboundDetailsDataContainer > .con-vs-loading')
    },
    async exportData () {
      this.$store.dispatch('setIsMainTableLoading', true)
      const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
      await AgentInboundDetailsReport.export({ ...this.searchParams, companyId: this.companyId, language, export: true }) // TODO: Process const response =
      this.$store.dispatch('setIsMainTableLoading', false)
    }
  }
}
</script>

<style scoped>

</style>
